<template>
  <div class="content-wrapper step-detail">
    <!-- <layout></layout> -->
    <crumbs :trails="trails"></crumbs>
    <div class="check-steps">
      <el-steps :active="active" :process-status="processStatus">
        <el-step title="媒体商信息提交">
          <div slot="description">
            <p>{{mediaDraw.MediaName}}</p>
            <p>{{mediaDraw.AddDateStr}}</p>
          </div>
        </el-step>
        <el-step title="运营审核">
          <div slot="description" v-if="approvalLog[0]">
            <p>{{approvalLog[0].OperatorName}}</p>
            <p>{{formatdate(approvalLog[0].AddDate)}}</p>
          </div>
        </el-step>
        <el-step title="杭州财务审核">
          <div slot="description" v-if="approvalLog[1]">
            <p>{{approvalLog[1].OperatorName}}</p>
            <p>{{formatdate(approvalLog[1].AddDate)}}</p>
          </div>
        </el-step>
        <el-step title="北京财务审核" icon="el-icon-check">
          <div slot="description" v-if="approvalLog[2]">
            <p>{{approvalLog[2].OperatorName}}</p>
            <p>{{formatdate(approvalLog[2].AddDate)}}</p>
          </div>
        </el-step>
      </el-steps>
      <div class="remark">
        <label for="remark">备注：</label>
        <textarea :value="approvalLog.length? approvalLog[approvalLog.length -1].Remark : ''" cols="30" rows="10" readonly></textarea>
      </div>
    </div>
    <div class="data-info">
      <div class="info-item">
        <h3 class="title">订单信息</h3>
        <el-form :inline="true" :model="mediaDraw" label-width="100px" class="demo-form-inline" label-position="right">
          <el-form-item label="申请时间：">
            <el-input readonly v-model="mediaDraw.AddDateStr" placeholder="申请时间"></el-input>
          </el-form-item>
          <el-form-item label="订单号：">
            <el-input readonly v-model="mediaDraw.OrderNumber" placeholder="订单号"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="info-item">
        <h3 class="title">媒体商信息</h3>
        <el-form :inline="true" :model="mediaDraw" label-width="100px" class="demo-form-inline" label-position="right">
          <el-form-item label="媒体商ID：">
            <el-input v-model="mediaDraw.UserId" placeholder="媒体商ID" readonly></el-input>
          </el-form-item>
          <el-form-item label="公司名称：">
            <el-input v-model="mediaDraw.CompanyName" placeholder="公司名称" readonly></el-input>
          </el-form-item>
          <el-form-item label="媒体运营：">
            <el-input v-model="mediaDraw.SourceOperator" placeholder="媒体运营" readonly></el-input>
          </el-form-item>
          <el-form-item label="媒介：">
            <el-input v-model="mediaDraw.Medium" placeholder="媒介" readonly></el-input>
          </el-form-item>
          <el-form-item label="合同公司：">
            <el-input v-model="mediaDraw.ContractCompany" placeholder="合同公司" readonly></el-input>
          </el-form-item>
          <el-form-item label="媒体商姓名：">
            <el-input v-model="mediaDraw.MediaName" placeholder="媒体商姓名" readonly></el-input>
          </el-form-item>
        </el-form>

      </div>
      <div class="info-item">
        <h3 class="title">结算信息</h3>
        <el-form :inline="true" :model="mediaDraw" label-width="100px" class="demo-form-inline" label-position="right">
          <el-form-item label="结算金额：">
            <el-input readonly v-model="mediaDraw.PretaxAmount" placeholder="结算金额"></el-input>
          </el-form-item>
          <el-form-item label="税后金额：" v-show="mediaDraw.AftertaxAmount === mediaDraw.PretaxAmount? false : true">
            <el-input readonly v-model="mediaDraw.AftertaxAmount" placeholder="税后金额"></el-input>
          </el-form-item>
          <el-form-item label="发票金额：">
            <el-input readonly v-model="mediaDraw.InvoiceAmount" placeholder="发票金额"></el-input>
          </el-form-item>
          <el-form-item label="打款户名：">
            <el-input readonly v-model="mediaDraw.BankUserName" placeholder="打款户名"></el-input>
          </el-form-item>
          <el-form-item label="打款账号：">
            <el-input readonly v-model="mediaDraw.BankAccount" placeholder="打款账号"></el-input>
          </el-form-item>
          <el-form-item label="支行信息：">
            <el-input readonly v-model="mediaDraw.BranchBankInfo" placeholder="支行信息"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="withdraw-detail-footer">
      <el-button type="primary" @click="back">返 回</el-button>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
// 面包屑
import crumbs from "../public/crumbs/newCrumbs";
// 工具函数
import { formatDateAll } from "common/js/common";
import { getMediaDrawInfo } from "api/mediaWithdraw";

export default {
  data() {
    return {
      mediaDraw: {},
      approvalLog: [],
      trails: [
        {
          trail: "财务管理",
          href: ""
        },
        {
          trail: "媒体提现审核",
          href: "IAD_MediaDraw"
        },
        {
          trail: "媒体提现进度",
          href: ""
        }
      ]
    };
  },
  computed: {
    active() {
      return this.approvalLog ? this.approvalLog.length : 0;
    },
    processStatus() {
      var lastStatus =
        this.approvalLog.length > 0
          ? this.approvalLog[this.approvalLog.length - 1].Status
          : 0;
      switch (lastStatus) {
        case 5:
          return "error";
          break;
        case 6:
          return "error";
          break;
        case 7:
          return "error";
          break;
        default:
          return "finish";
          break;
      }
    }
  },
  components: {
    crumbs
  },
  methods: {
    getWithdrawDetail() {
      var sendData = {
        BusinessId: this.$route.params.id
      };
      getMediaDrawInfo(sendData).then(res => {
        if(res.mediaDraw) {
           this.mediaDraw = Object.assign({}, this.mediaDraw, res.mediaDraw);
        } else {
          this.this.mediaDraw = {};
        }
        if(res.approvalLog) {
          this.approvalLog = res.approvalLog;
        } else {
          this.approvalLog = []
        }
      })
      .catch(err => {
        this.this.mediaDraw = {};
        this.approvalLog = []
      });
    },
    formatdate(oldDate) {
      return formatDateAll(oldDate);
    },
    back() {
      this.$router.go(-1);
    }
  },
  created() {
    document.title = "媒体商提现进度";
    this.getWithdrawDetail();
  },
  mounted() {}
};
</script>
<style>
.navbar {
  min-height: none;
  max-height: 50px;
}
ul.nav {
  padding: 0 !important;
}
#navbar .sign-in-wrap {
  padding-right: 50px !important;
}
.launchTime .el-date-editor .el-range-separator {
  width: 10% !important;
}
#edui1_iframeholder {
  max-height: 177px !important;
  overflow: auto !important;
}
.money-icon {
  margin-right: 5px !important;
}
.areaWindow .el-dialog {
  width: 940px !important;
  margin-top: 4vh !important;
}
.areaWindow .el-dialog__body {
  padding: 8px 32px 75px !important;
}
.putonArea .region {
  margin-top: 4px !important;
}
.putonArea .region .provinces-group {
  width: 650px !important;
}
.putonArea .region .provinces-group .provinces {
  border: 1px solid transparent;
}
.putonArea .region .provinces-group .provinces .cities-group {
  max-height: 150px !important;
  font-size: 14px !important;
  border: 1px solid #ccc !important;
  border-left: none !important;
}
.putonArea .region .provinces-group .provinces.mouseon .cities-group .cities {
  border-right: none !important;
  border-bottom: none !important;
}
.el-select-dropdown__wrap {
  margin-right: -71px !important;
}
</style>
<style lang="scss">
@import "../../common/scss/color.scss";
.step-detail {
  .check-steps {
    width: 90%;
    overflow: hidden;
    padding: 50px 80px 20px;
    background-color: #f5f5f5;
    margin-left: 50%;
    transform: translateX(-50%);
    .el-steps {
      .el-step {
        position: relative;
        .el-step__title {
          font-size: 14px;
          font-weight: 700;
          color: #101010;
          width: 140px;
          text-align: center;
          position: absolute;
          top: -50px;
          left: 0;
          transform: translateX(-41%);
        }
        .el-step__description {
          width: 110px;
          text-align: center;
          padding-top: 20px;
          transform: translateX(-22%);
        }
        .el-step__line {
          height: 10px;
          top: 10px;
        }
        .el-step__icon {
          width: 29px;
          height: 29px;
          border-color: #bbbbbb;
        }
        .is-finish {
          border-color: #97da95;
          .el-step__icon {
            border-color: #97da95;
            background-color: #97da95;
            color: #fff;
          }
          .el-step__line {
            background-color: #97da95;
          }
        }
        .is-error .el-step__icon {
          border-color: #e6232a;
          background-color: #e6232a;
          color: #fff;
        }
        .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
          font-weight: 700;
        }
        .is-icon {
          border-radius: 15px;
        }
      }
    }
    .remark {
      margin-top: 10px;
      textarea {
        vertical-align: middle;
        width: 90%;
        height: 100px;
        border: none;
        border-radius: 10px;
        padding: 20px;
      }
    }
  }
  .data-info {
    width: 97%;
    margin: 0 auto;
    .info-item {
      margin: 10px 0;
      .title {
        border-bottom: 2px solid #dedede;
        line-height: 25px;
        color: #101010;
        font-weight: 500;
        font-size: 18px !important;
      }
      .el-form {
        padding: 20px 0;
        .el-form-item {
          margin-right: 38px;
          .el-input {
            width: 125%;
          }
        }
      }
    }
  }
  .withdraw-detail-footer {
    padding: 30px 0;
    text-align: center;
    .el-button {
      width: 140px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/financial-management/withdraw-detail.vue